// removed by extract-text-webpack-plugin
module.exports = {"this":"HRUbrnRFSTf4tO6_U6u_n"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/easy/public/Comps/ui/Draw/ScrapingPrize.scss
// module id = 940
// module chunks = 12